import { FC } from "react";
import { useDownload } from "../../../../../../../hooks/useDownload";
import { Box, Grid, IconButton, TextField, Typography } from "@mui/material";
import RequestQuoteIcon from "@mui/icons-material/RequestQuote";
import { PaperEditBillTable } from "../PaperEditBillTable";
import { PaperBillCardProps } from "../../types/PaperBillCard.types";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";

export const PaperBillCard: FC<PaperBillCardProps> = ({
  bill,
  todayString,
  selectedRxId,
  notes,
  updateNote,
  onRowClick,
  setSelectedRxId,
  handleMenuOpen,
  onRemoveAll,
}) => {
  const { accountInfo, data, billNumber, userInfo, billId } = bill;
  const { rxs, payerDto, totalPrice } = data;
  const totalPriceFormatted = Number(totalPrice).toFixed(2).toString().replace(".", ",");
  const { handleDownloadPdf } = useDownload();

  return (
    <Box className="bill-card-header">
      <Grid
        container
        justifyContent="left"
        alignItems="center"
      >
        <Grid
          item
          xs={1}
        >
          <IconButton
            onClick={() => onRemoveAll(billId)}
            style={{ color: "#ff5722" }}
          >
            <RemoveCircleOutlineIcon />
          </IconButton>
        </Grid>
        <Grid
          item
          xs={11}
        >
          <Box
            className="bill-card-body"
            display="flex"
            justifyContent="center"
            alignItems="center"
            gap={1}
          >
            <Typography
              variant="h6"
              textAlign="center"
            >
              {payerDto?.name}
            </Typography>
            {bill.docDto?.id && (
              <IconButton
                className="fancy-button"
                onClick={() => handleDownloadPdf(bill.docDto.id)}
                title="PDF herunterladen"
              >
                <RequestQuoteIcon />
              </IconButton>
            )}
          </Box>
        </Grid>
      </Grid>
      <Box sx={{ m: 1 }}>
        <Grid
          container
          spacing={1}
          alignItems="center"
          sx={{ mb: 2 }}
        >
          <Grid
            item
            xs={6}
          >
            <Typography
              variant="subtitle1"
              align="center"
            >
              Mandant
            </Typography>
            <Box className="box">
              <Typography variant="subtitle2">{accountInfo.name}</Typography>
            </Box>
          </Grid>
          <Grid
            item
            xs={6}
          >
            <Typography
              variant="subtitle1"
              align="center"
            >
              Erstellt von
            </Typography>
            <Box className="box">
              <Typography variant="subtitle2">
                {userInfo.firstName + " " + userInfo.lastName}
              </Typography>
            </Box>
          </Grid>
          <Grid
            item
            xs={4}
          >
            <Typography
              variant="subtitle1"
              align="center"
            >
              Bill-ID
            </Typography>
            <Box className="box">
              <Typography variant="subtitle2">{billNumber}</Typography>
            </Box>
          </Grid>
          <Grid
            item
            xs={4}
          >
            <Typography
              variant="subtitle1"
              align="center"
            >
              Startdatum
            </Typography>
            <Box className="box">
              <Typography variant="subtitle2">{todayString}</Typography>
            </Box>
          </Grid>
          <Grid
            item
            xs={4}
          >
            <Typography
              variant="subtitle1"
              align="center"
            >
              Gesamtpreis
            </Typography>
            <Box className="box">
              <Typography variant="subtitle2">{totalPriceFormatted} €</Typography>
            </Box>
          </Grid>
        </Grid>

        {rxs.length > 0 ? (
          <PaperEditBillTable
            rxs={rxs}
            selectedRxId={selectedRxId}
            onRowClick={(row) => {
              onRowClick(row);
              setSelectedRxId(row.id);
            }}
            onMenuOpen={handleMenuOpen}
          />
        ) : (
          <Typography
            variant="h6"
            align="center"
          >
            Keine Rechnungsrezepte zum Versenden an die {payerDto?.name} bereit.
          </Typography>
        )}

        <Box className="notes-section">
          <TextField
            sx={{ mr: 1, mb: 1 }}
            className="notes-textfield"
            placeholder="Notizen hinzufügen..."
            fullWidth
            value={notes[billId] || ""}
            onChange={(e) => {
              const updatedNote = e.target.value;
              updateNote(billId, updatedNote);
            }}
          />
        </Box>
      </Box>
    </Box>
  );
};
